import axios from "axios";
import {hostWithPrefix} from "../../common/ApiCommon";
import {toaster} from "evergreen-ui";

function createEvapReq(constructorData, name, period) {
  return {
    name: name,
    period: period,
    template: createEvapTemplate(constructorData, name)
  };
}

export function createEvapTemplate(constructorData, name) {
  return  {
    type: 'EVAPORATION',
    station: {
      id: constructorData.station.id,
      name: constructorData.station.name,
    },
    name : name,
    filter: {
      waterTemperatureFilterObject: {
        meteoCode: constructorData.waterTemperatureFilterObject.meteoCode === null
        || constructorData.waterTemperatureFilterObject.meteoCode.id === -1 ? null : {
          id: constructorData.waterTemperatureFilterObject.meteoCode.id,
          code: constructorData.waterTemperatureFilterObject.meteoCode.code,
        },
        type: constructorData.waterTemperatureFilterObject.type === null
        || constructorData.waterTemperatureFilterObject.type.id === -1 ? null : {
          id: constructorData.waterTemperatureFilterObject.type.id,
          name: constructorData.waterTemperatureFilterObject.type.name
        }
      },
      windSpeedFilterObject: {
        meteoCode: constructorData.windSpeedFilterObject.meteoCode === null
        || constructorData.windSpeedFilterObject.meteoCode.id === -1 ? null :{
          id: constructorData.windSpeedFilterObject.meteoCode.id,
          code: constructorData.windSpeedFilterObject.meteoCode.code,
        },
        type: constructorData.windSpeedFilterObject.type === null
        || constructorData.windSpeedFilterObject.type.id === -1 ? null : {
          id: constructorData.windSpeedFilterObject.type.id,
          name: constructorData.windSpeedFilterObject.type.name
        }
      },
      stationEntityObject: {
        id: constructorData.stationEntity.id,
        name: constructorData.stationEntity.name
      }
    }
  }
}

export function generateEvaporationReport(period, constructorData, name) {
  const req = createEvapReq(constructorData, name, period)

  return axios({
    url: 'http://' + hostWithPrefix + '/api/outputforms/evaporation', //your url
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: JSON.stringify(req),
  });
}

export function saveEvapTemplate(constructorData, name) {
  const req = createEvapTemplate(constructorData, name)
  axios({
    url: 'http://' + hostWithPrefix + '/templates/evaporation', //your url
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: JSON.stringify(req),
  }).then((response) => {
    toaster.success('Шаблон сохранён!')
  }).catch((err) => {
    if (err.response.status === 400) {
      toaster.danger("Некорректный запрос! Возможно шаблон с таким именем уже существует.")
    } else {
      toaster.danger("Не получилось!")
    }
  });
}